import { JwtService } from "./Jwt.service";

type User = {
  email?: string;
  firstName?: string;
  lastName?: string;
  id?: string;
  authorities?: ("ROLE_USER" | "ROLE_ADMIN")[];
};

class GoogleTagManager {
  private initialized = false;

  isEmployee(user: User): boolean {
    if (!user.email) {
      return false;
    }

    return /@cleverfarm\./i.test(user.email);
  }

  initialize(user: User): void {
    if (this.initialized) {
      return;
    }

    const isInternalUser =
      this.isEmployee(user) || JwtService.isImpersonatedToken();

    /**
     * this is used to determine if user is internal or not later in google analytics UI
     */
    if (isInternalUser) {
      document.cookie = "_cleverfarm_internal=true; max-age=31536000; path=/";
    } else {
      document.cookie = "_cleverfarm_internal=false; max-age=31536000; path=/";
    }

    this.initialized = true;
  }

  isInitialized(): boolean {
    return this.initialized;
  }
}

const GoogleTagManagerService = new GoogleTagManager();
export { GoogleTagManagerService };
